export default __webpack_public_path__ + "images/wall-access.e37a95c7289d9d03f4a9afaf733d2734.png";